import { call, put, takeEvery } from "redux-saga/effects";
import * as Action from "../actions/Actions";
import { getEnvironment } from "../../utils/utils";
import type { IKeyWords, IWebSites } from "../../InterfacesTypes/interfaces";
import { DISPATCHES } from "../../InterfacesTypes/enums";
import { spGet } from "../../utils/SharepointAPI";
import { fetchQuickLinks } from "state/Reducers/QuickLinksReducer";
import { fetchImages } from "state/Reducers/HeroImageReducer";
import { fetchNavigationItems } from "state/Reducers/NavigationItemsReducer";
import { fetchResourceLinks } from "state/Reducers/ResourceLinksReducer";
import { fetchFooterSectionImages } from "state/Reducers/FooterSectionImagesReducer";
import { fetchRecentlyUpdatedFiles } from "state/Reducers/RecentlyUpdatedFilesReducer";
// import { fetchRecentlyUpdatedPages } from "state/Reducers/RecentlyUpdatedPagesReducer";
import { fetchCurrentNews } from "state/Reducers/CurrentNewsReducer";
import { fetchBannerImage } from "state/Reducers/BannerImageReducer";
import { fetchTitleTexts } from "state/Reducers/TitleTextReducer";

const env = getEnvironment();

function* initializeApplication() {
  //--------- yield call for SP KeyWords list data
  const keyWordsData: IKeyWords[] = yield call(
    spGet,
    `${env.listapi}/getByTitle('KeyWords')/Items?$select=Id,KeyWords,WebSiteURLIDIndex&$top=4999`
  );
  yield put(Action.setSPKeyWordsData(keyWordsData));
  //--------- yield call for SP WebSiteUrls list data
  const webSiteData: IWebSites[] = yield call(
    spGet,
    `${env.listapi}/getByTitle('WebSiteURLs')/Items?$select=Id,URL,WebSiteURLIDIndex,SiteImage,Protected,Title&$top=4999`
  );
  const firstSubDomain = window.location.hostname.split(".")[0];
  yield put(Action.setSPWebSitesData(webSiteData));
  yield put(fetchNavigationItems());
  yield put(fetchResourceLinks());
  yield put(fetchQuickLinks());
  yield put(fetchImages());
  yield put(fetchBannerImage());
  yield put(fetchFooterSectionImages());
  yield put(fetchTitleTexts());
  if (firstSubDomain !== "logistikportalen") {
    yield put(fetchRecentlyUpdatedFiles());
  }
  //yield put(fetchRecentlyUpdatedPages());
  yield put(fetchCurrentNews());
}

export function* initializeApplicationSaga() {
  yield takeEvery(DISPATCHES.INITIALIZE_SAGA, initializeApplication);
}
